import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Debug logging to see what we're getting
console.log('Environment variables check:');
console.log('REACT_APP_SUPABASE_URL:', supabaseUrl ? 'SET' : 'NOT SET');
console.log('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'SET' : 'NOT SET');

// Check if Supabase is properly configured
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not found. Please configure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your environment variables.');
}

// Only create the client if we have valid credentials
let supabase = null;
if (supabaseUrl && supabaseAnonKey && supabaseUrl !== 'your_supabase_project_url_here' && supabaseAnonKey !== 'your_supabase_anon_key_here') {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
} else {
  // Create a mock client for development
  supabase = {
    from: () => ({
      insert: () => Promise.resolve({ data: null, error: null }),
      select: () => ({
        eq: () => Promise.resolve({ data: null, error: null })
      })
    })
  };
}

export { supabase };

// Function to add email to Android waitlist
export const addToAndroidWaitlist = async (email) => {
  try {
    // Check if we have a real Supabase client
    if (!supabase || !process.env.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL === 'your_supabase_project_url_here') {
      return { success: false, error: 'Supabase not configured' }
    }

    const { data, error } = await supabase
      .from('android_waitlist')
      .insert([
        { 
          email: email,
          created_at: new Date().toISOString()
        }
      ])
    
    if (error) {
      throw error
    }
    
    return { success: true, data }
  } catch (error) {
    console.error('Error adding to waitlist:', error)
    return { success: false, error: error.message }
  }
}

// Function to check if email already exists in waitlist
export const checkEmailExists = async (email) => {
  try {
    // Check if we have a real Supabase client
    if (!supabase || !process.env.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL === 'your_supabase_project_url_here') {
      return { exists: false, error: 'Supabase not configured' }
    }

    const { data, error } = await supabase
      .from('android_waitlist')
      .select('email')
      .eq('email', email)
      .single()
    
    if (error && error.code !== 'PGRST116') { // PGRST116 is "not found" error
      throw error
    }
    
    return { exists: !!data, error: null }
  } catch (error) {
    console.error('Error checking email:', error)
    return { exists: false, error: error.message }
  }
}

// Function to add email to Apple waitlist
export const addToAppleWaitlist = async (email) => {
  try {
    // Check if we have a real Supabase client
    if (!supabase || !process.env.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL === 'your_supabase_project_url_here') {
      return { success: false, error: 'Supabase not configured' }
    }

    const { data, error } = await supabase
      .from('apple_waitlist')
      .insert([
        { 
          email: email,
          created_at: new Date().toISOString()
        }
      ])
    
    if (error) {
      throw error
    }
    
    return { success: true, data }
  } catch (error) {
    console.error('Error adding to Apple waitlist:', error)
    return { success: false, error: error.message }
  }
}

// Function to check if email already exists in Apple waitlist
export const checkAppleEmailExists = async (email) => {
  try {
    // Check if we have a real Supabase client
    if (!supabase || !process.env.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL === 'your_supabase_project_url_here') {
      return { exists: false, error: 'Supabase not configured' }
    }

    const { data, error } = await supabase
      .from('apple_waitlist')
      .select('email')
      .eq('email', email)
      .single()
    
    if (error && error.code !== 'PGRST116') { // PGRST116 is "not found" error
      throw error
    }
    
    return { exists: !!data, error: null }
  } catch (error) {
    console.error('Error checking Apple email:', error)
    return { exists: false, error: error.message }
  }
}
